import { Tag } from "lucide-react";

import { useGetList, useTranslate } from "ra-core";

import { ResponsiveFilters } from "../misc/ResponsiveFilters";

import { ToggleFilterButton } from "@/components/admin/toggle-filter-button";

import { Badge } from "@/components/ui/badge";

import { FilterCategory } from "../filters/FilterCategory";

import type { Tag as TagType } from "../types";

import { COMPANY_TAG_GROUPS, normalizeTagName } from "./companyTagGroups";

export const CompanyListFilter = () => {
  const translate = useTranslate();

  const { data: tags = [] } = useGetList<TagType>("tags", {
    pagination: {
      page: 1,
      perPage: 100,
    },

    sort: {
      field: "name",
      order: "ASC",
    },
  });

  const groupedNames = new Set(
    COMPANY_TAG_GROUPS.flatMap((group) => group.names.map(normalizeTagName)),
  );

  const otherTags = tags.filter(
    (tag) => !groupedNames.has(normalizeTagName(tag.name)),
  );

  return (
    <ResponsiveFilters
      filtersLabel="Фильтры компаний"
      searchInput={{
        placeholder: translate("resources.companies.filters.search"),
      }}
    >
      {COMPANY_TAG_GROUPS.map((group) => {
        const groupTags = tags.filter((tag) =>
          group.names.some(
            (name) => normalizeTagName(name) === normalizeTagName(tag.name),
          ),
        );

        if (groupTags.length === 0) {
          return null;
        }

        return (
          <FilterCategory
            key={group.key}
            icon={<Tag className="h-4 w-4" />}
            label={group.title}
          >
            {groupTags.map((tag) => (
              <ToggleFilterButton
                key={tag.id}
                className="w-full justify-between"
                label={
                  <Badge
                    variant="secondary"
                    className="rovero-colored-tag text-[#482719] font-normal"
                    style={{
                      backgroundColor: tag.color,
                    }}
                  >
                    {tag.name}
                  </Badge>
                }
                value={{
                  "tags@cs": `{${tag.id}}`,
                }}
              />
            ))}
          </FilterCategory>
        );
      })}

      {otherTags.length > 0 && (
        <FilterCategory icon={<Tag className="h-4 w-4" />} label="Другие">
          {otherTags.map((tag) => (
            <ToggleFilterButton
              key={tag.id}
              className="w-full justify-between"
              label={
                <Badge
                  variant="secondary"
                  className="rovero-colored-tag text-[#482719] font-normal"
                  style={{
                    backgroundColor: tag.color,
                  }}
                >
                  {tag.name}
                </Badge>
              }
              value={{
                "tags@cs": `{${tag.id}}`,
              }}
            />
          ))}
        </FilterCategory>
      )}
    </ResponsiveFilters>
  );
};
